import './product-support-tabs.scss';

import { TabBar } from '../../components/tab-bar/tab-bar';

class ProductSupportTabs {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-howtovideos',
            itemsAttr: 'items',
            itemAttr: 'item',
            videoAttr: 'video',
            trackingAttr: 'data-trackingcategory',
            resizeHandler: null
        };

        this.settings = Object.assign({}, settings, options);

        this.$productSupportTabs = element;
    }

    initialize () {
        this.$tabBar = this.$productSupportTabs.querySelector('[data-tab-bar-root="product-support"]');

        if (this.$tabBar) {
            this.initTabbar();
        }
    }

    initTabbar () {
        this.tabBar = new TabBar({
            $tabBar: this.$tabBar,
            resizeHandler: this.settings.resizeHandler
        });
        this.tabBar.init();
        setTimeout(() => {
            this.setTabBarContentHeight();
        }, 1000);

        this.settings.resizeHandler.customFunctions.push(() => {
            this.setTabBarContentHeight();
        });
    }

    setTabBarContentHeight () {
        const $tabBarContent = document.querySelector('.product-support-tabs__tab-bar-content');
        const $activeContentItem = $tabBarContent.querySelector('.tab-bar__content-item--active');
        const activeContentItemHeight = $activeContentItem.offsetHeight;
        $tabBarContent.style.height = activeContentItemHeight + 'px';
    }
}

export { ProductSupportTabs };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$productSupportTabs = $context.querySelectorAll('[data-product-support-tabs="root"]');

        if ($$productSupportTabs.length > 0) {
            for (let i = 0; i < $$productSupportTabs.length; i++) {
                const $productSupportTabsItem = new ProductSupportTabs($$productSupportTabs[i], {
                    loader: window.OPTIONS.loader,
                    resizeHandler: window.resizeHandler
                });
                $productSupportTabsItem.initialize();
            }
        }
    }
});
